import React from 'react'
import ReactTable from 'react-table'
import styled from 'styled-components'
import { MdChevronLeft, MdChevronRight } from 'react-icons/lib/md'
import matchSorter from 'match-sorter'
import 'react-table/react-table.css'

import media from '../utils/style-utils'

const Previous = styled(({disabled, ...others}) =>
  <MdChevronLeft size={24} {...others} />
)`
  cursor: ${props => props.disabled ? '' : 'pointer'};
  color: ${props => props.disabled ? props.theme.colors.disabled : props.theme.colors.text}      
`

const Next = styled(({disabled, ...others}) =>
  <MdChevronRight size={24} {...others} />
)`
  cursor: ${props => props.disabled ? '' : 'pointer'};
  color: ${props => props.disabled ? props.theme.colors.disabled : props.theme.colors.text}      
`

// const columnWidth = (rows, accessor, headerText) => {
//   if (!rows) return
//   const maxWidth = 400
//   const magicSpacing = 12
//   let cellLength = Math.max(
//     ...rows.map(row => (`${row[accessor]}` || '').length),
//     headerText.length
//   )
//   return Math.min(maxWidth, cellLength * magicSpacing)
// }

const Table = ({children, onRowClick, filterable, data, columns, ...others}) => {
  return (
    <ReactTable
      data={data}
      columns={columns}
      filterable={filterable}
      defaultFilterMethod={(filter, row) => matchSorter([row[filter.id]], filter.value).length}
      getTrProps={(state, rowInfo) => ({
        onClick: () => onRowClick ? onRowClick(rowInfo.original) : null
      })}
      defaultPageSize={10}
      minRows={0}
      PreviousComponent={({onClick, disabled}) => <Previous onClick={onClick} disabled={disabled} />}
      NextComponent={({onClick, disabled}) => <Next onClick={onClick} disabled={disabled} />}
      {...others}
    />
  )
}

export default styled(({...others}) =>
  <Table {...others} />
)`
  &&& {
    font-size: ${props => props.theme.fontSizes[1]}px;
    border-radius: ${props => props.theme.radii[2]}px;
    flex: 1;
    margin-bottom: 1rem;
    
    .rt-thead {
      border-radius: ${props => props.theme.radii[2]}px 0;
      background-color: #f5f5f5;
      box-shadow: none;
      border-bottom: 1px solid #e0e0e0;
      
      &.-filters .rt-th {
        border: none;
      }
    }
    
    .rt-th {
      border: none;
      text-align: left;
      color: #707070;
      outline: none;
      padding-top: 1rem;      
      padding-bottom: 1rem;      
    }
    
    .rt-tbody {
      .rt-tr {
        color: ${props => props.theme.colors.text};
        border: 0;
        padding-top: .5rem;      
        padding-bottom: .5rem;      
        cursor: pointer;
        
        &.-padRow {
          cursor: default;
        }
        
        &:not(.-padRow):hover {
          background: ${props => props.theme.colors.highlight};
        }
      
        .rt-td {
          border: 0;
        }
      }
      
      .rt-tr-group {
        border: 0;
        flex: 0 0;
      }
    }
    
    .-pagination {
      border-top: 1px solid #e0e0e0;
      box-shadow: none;
      
      .-center {
        order: 1;
        flex: 1;
        justify-content: space-between;
        
        .-pageSizeOptions {
          order: 1;
          height: 100%;
          margin-top: 0;
          margin-bottom: 0;
          padding-top: 3px;
          padding-bottom: 3px;
          display: none;
          
          ${media.greaterThan('small')`{
              display: block;
          }`};
          
          select {
            height: 100%;
          }
        }
        
        .-pageInfo {
          order: 2;
        }
      }
    }
    
    .-previous {
      order: 2;
      flex: 0 0 50px;
      padding-top: 3px;
    }
    
    .-next {
      order: 3;
      flex: 0 0 50px;
      padding-top: 3px;
    }
  }
`


// WEBPACK FOOTER //
// ./src/components/Table.js